// A categoria que não comissiona precisa se anunciar na listagem: é ela que explica por que
// o item da comanda saiu com comissão zero no extrato do colaborador. Por isso só ela ganha
// selo; uma coluna cheia de selo esconderia justamente a linha que interessa.
//
// O caso comum ainda assim é escrito, em texto apagado: a célula vazia era lida como campo
// que não gravou, e quem acabava de salvar a categoria voltava para conferir.
const commissionableRenderer = (params) =>
	params.data?.commissionable === false
		? <span className="badge light badge-warning">Não comissiona</span>
		: <span className="text-muted">Comissiona</span>;

// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true
	},
	{
		headerName: 'commission',
		field: 'commissionable',
		width: 170,
		cellRenderer: commissionableRenderer
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]